import { PageType } from "@product/scmp-sdk";

export const pathname = "/posties";

export const page = {
  route(query: QueryParameters) {
    return { pathname, query: { ...query, pageType: PageType.Posties } };
  },
};
